import { Drawer } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';

export const DrawerComponent = ({
  transitionDuration,
  anchor,
  className,
  slideProps,
  open,
  onClose,
  children,
}) => (
  <Drawer
    transitionDuration={transitionDuration}
    anchor={anchor}
    className={className}
    open={open}
    onClose={onClose}
    SlideProps={slideProps}
  >
    {children}
  </Drawer>
);

DrawerComponent.propTypes = {
  children: PropTypes.node.isRequired,
  transitionDuration: PropTypes.number,
  anchor: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  slideProps: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
